import SingleSubscription from './SingleSubscription';

export default SingleSubscription;
